import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { DistributionChainState } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  templateUrl: './column-blocked-for-return.component.html',
  styleUrls: ['./column-blocked-for-return.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatChip, AgrI18nSharedModule],
})
export class ColumnBlockedForReturnComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public readonly distributionChainState = DistributionChainState;
  public initCallback: () => void;

  constructor() {}

  ngAfterViewInit() {
    this.initCallback();
  }
}
